import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ChannelBaseDataObject } from 'models/service';

export const getChannels = async (params: { limit?: number; offset?: number; organization_id?: string }) =>
  apiClient.get<ChannelBaseDataObject[], ApiClientResponse<ChannelBaseDataObject[]>>(routes.channels.find, {
    params,
  });
